export function FeatureCard({ icon: Icon, title, description }) {
  return (
    <div className="flex items-start gap-4 bg-white p-4 sm:p-3 rounded-lg sm:rounded-md shadow-sm sm:shadow-none border border-gray-100 sm:border-none hover:shadow-md sm:hover:shadow-none transition-shadow duration-200">
      <div className="flex items-center justify-center w-10 h-10 sm:w-8 sm:h-8 bg-blue-50 rounded-full flex-shrink-0">
        <Icon className="text-blue-600 w-5 h-5 sm:w-5 sm:h-5" />
      </div>
      <div className="flex-1 min-w-0 text-left">
        <h3 className="font-semibold text-base sm:text-base text-gray-800 sm:text-gray-700 mb-2 sm:mb-1 leading-tight">{title}</h3>
        <p className="text-gray-600 text-sm leading-relaxed">{description}</p>
      </div>
    </div>
  )
}